export const flightType = {
  roundTrip: "往復",
  oneWay: "片道",
  multiCity: "周遊(2都市以上の滞在)",
};
